<template>
  <div class="community_outer">
    <div class="community_container" @click="clickShowPointDetail">
      <div class="c_left">
        <img :src="myData.url" class="c_l_img"/>
        <p class="left_match" v-if="!isExport" :style="{background: matchColor[Math.ceil(myData.match/0.2)]}">
          推荐度:{{(myData.match*100).toFixed(0)}}%
        </p>
      </div>
      <div class="c_row_1">
        <span class="c_name">{{ myData.name }}</span>
        <span class="c_address">{{ myData.location }}</span>
      </div>
      <div class="c_row_2 label_groups">
        <!-- <div class="label_item">{{ myData.tradeArea }}</div> -->
        <div class="label_item" v-if="myData.place_type">{{ myData.place_type }}</div>
        <div class="label_item">房屋均价：￥{{ myData.housesPrice | toFixed2 }}/㎡</div>
        <div class="label_item">物业费：￥{{ myData.maintenanceCharge | toFixed2 }}/㎡</div>
        <div class="label_item">{{ buh }}</div>
        <!-- <div class="label_item">{{ myData.deviceCount }}屏</div> -->
        <div class="label_item">{{myData.audienceNumber}}人次</div>
      </div>
      <div class="c_row_3">
        <span class="color_default">总价：</span>
        <span class="color_primary">￥<i class="num_font">{{ myData.allSelectSlotAmount | toFixed2 }}</i></span>

        <template v-if="isSmallSn">
          <span class="color_default" style="margin-left: 20px;">单价：</span>
          <span class="color_primary">￥<i class="num_font">{{ myData.price | toFixed2 }}</i></span>/屏/天
        </template>
        <template v-else>
          <p class="mg20">
            <template>单价:</template>
            <template v-if="myData.price">
              <span class="color_primary">￥<i class="num_font">{{ myData.price }}</i></span>/屏/天
            </template>
            <template v-else>暂无</template>
          </p>
<!--          <p class="mg20">-->
<!--            <template>梯外:</template>-->
<!--            <template v-if="myData.price">-->
<!--              <span class="color_primary">￥<i class="num_font">{{ myData.twPrice }}</i></span>/屏/天-->
<!--            </template>-->
<!--            <template v-else>暂无</template>-->
<!--          </p>-->
        </template>
        
        <span class="c_r_right"><span class="color_default">
          已选点位：</span><span class="color_primary num_font">{{ myData.allSelectDeviceCount }}</span>
          /<i class="num_font">{{ myData.allDeviceCount }}</i><i class="iconfont icon-qiehuanyou"></i>
        </span>
      </div>
    </div>
    <SelectCommunityDevice ref="SelectCommunityDevice" @change="deviceCheckChange"></SelectCommunityDevice>
  </div>
</template>

<script>
import SelectCommunityDevice from '../dialog/SelectCommunityDevice'

export default {
  name: 'MyCommunityInfo',
  components: {
    SelectCommunityDevice
  },
  filters: {
    toFixed2 (nv) {
      return new Number(nv).toFixed(2)
    }
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isExport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      matchColor: ['#B59A9A', '#B59A9A', '#C88290', '#DB6A87', '#ED527D', '#FF3973']
    }
  },
  computed: {
    myData: {
      get () {
        return this.data
      },
      set (nv) {
        this.$emit('update:data', nv)
      }
    },
    buh () {
      let { buildingNumber, unitNumber, housesNumber } = this.myData
      if (!buildingNumber) return ''
      return `${buildingNumber}栋楼-${unitNumber}单元` + (housesNumber && housesNumber > -1 ? '-' + housesNumber + '户' : '')
    },
    isSmallSn () { // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName
      return name.toLowerCase().indexOf('smallsn') > -1
    }
  },
  methods: {
    clickShowPointDetail () {
      this.$refs.SelectCommunityDevice.show(this.myData, this.isExport)
    },
    deviceCheckChange (data) {
      this.myData.buildDeviceList = data.buildDeviceList
      this.myData.twBuildDeviceList = data.twBuildDeviceList
      this.myData.tnSelectSlotAmount = data.tnSelectSlotAmount
      this.myData.tnSelectDeviceCount = data.tnSelectDeviceCount
      this.myData.twSelectSlotAmount = data.twSelectSlotAmount
      this.myData.twSelectDeviceCount = data.twSelectDeviceCount
      this.myData.allSelectSlotAmount = data.allSelectSlotAmount
      this.myData.allSelectDeviceCount = data.allSelectDeviceCount
      this.myData.checked = data.check
    }
  }
}
</script>

<style lang="scss" scoped>
.community_outer {
  display: inline-block;
}
.community_container {
  display: grid;
  grid-template-columns: 90px auto;
  grid-template-rows: 22px auto 20px;
  grid-column-gap: 10px;
  margin: 15px 0;
}
.c_left {
  grid-row: 1 / 4;
  .left_match {
    position: relative;
    z-index: 1;
    height: 16px;
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: #eee;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 16px;
    text-align: center;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: -16px;
  }
}
.c_l_img {
  display: block;
  width: 90px;
  height: 90px;
  border-radius: 4px;
  border: 1px solid #eee; // delete
}
.c_row_1 {
  .c_name {
    color: #282729;
    font-size: 16px;
    line-height: 22px;
  }
  .c_address {
    padding: 2px 0 3px 10px;
    color: #999999;
    font-size: 12px;
    line-height: 17px;
  }
}
.label_groups {
  padding: 6px 0;
  .label_item {
    display: inline-block;
    padding: 4px 8px 3px;
    margin: 4px 0;
    color: #666;
    line-height: 17px;
    font-size: 12px;
    background-color: #f5f5f5;
    border-radius: 4px;
    &:not(:first-child) {
      margin-left: 4px;
    }
  }
}
.c_row_3 {
  color: #282729;
  font-size: 14px;
  font-family: Akrobat;
  line-height: 20px;
  .c_r_right {
    margin-left: 20px;
  }
  .mg20 {
    display: inline-block;
    margin-left: 20px;
  }
  .num_font {
    font-size: 16px;
    font-weight: bolder;
  }
}
.color_default {
  color: #999999;
}
.color_primary {
  color: #FF3973;
}
.icon-qiehuanyou {
  color: #282729;
  font-size: 12px;
  margin-left: 10px;
}
</style>


